module.exports = __webpack_public_path__ + "static/media/aeroStreamServiceActive.a4d06ebd.png";